import { Getter } from 'jotai';

import { deleteAssetMutationAtom } from '../_graphql/mutationAssetDelete';
import { updateAssetMutationAtom } from '../_graphql/mutationAssetUpdate';

import * as assetDetailState from './assetDetail.state';

const refetchData = (get: Getter) => {
  get(assetDetailState.$remoteAsset).refetch();
};

// 🟠🟠🟠 ACTION -> UPDATE asset
export const $updateRemoteAsset = updateAssetMutationAtom({
  onSuccess: refetchData,
});

// 🟠🟠🟠 ACTION -> DELETE asset
export const $deleteRemoteAsset = deleteAssetMutationAtom({
  onSuccess: refetchData,
});
